import React from 'react'

export function CloseIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M17.2114 2.00001L16 0.782867L9 7.78287L2 0.782867L0.788574 2.00001L7.78857 9.00001L0.788574 16L2 17.2114L9 10.2114L16 17.2114L17.2114 16L10.2114 9.00001L17.2114 2.00001Z" fill="#6C757D"/>
    </svg>
  )
}